<ng-container *ngIf="height$ | async as height">
  <div class="activities" [ngStyle]="{'height.px': height }">
    <ng-container *ngIf="activities$ | async as activities">
      <ng-scrollbar *ngIf="activities.entities.length > 0" [ngStyle]="{'min-height.px': height }">
        <div class="activities__content">
          <app-activity *ngFor="let activity of activities.entities;let i = index;" [index]="i" [activity]="activity"></app-activity>
          <ng-container *ngIf="activities.entities.length < 1">
            <div class="activities__empty">
              <img class="activities__empty-image" src="/img/svg/activity.svg" />
              <div class="activities__empty-text">No User Activity Yet</div>
            </div>
          </ng-container>
        </div>
      </ng-scrollbar>
      <ng-container *ngIf="activities.entities.length < 1">
        <div class="activities__empty">
          <img class="activities__empty-image" src="/img/svg/activity.svg" />
          <div class="activities__empty-text">No User Activity Yet</div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-container>